import {Component, inject, Input} from '@angular/core';
import {NbDialogRef} from '@nebular/theme';
import {translations} from '../../../../../compob2b-admin/src/environments/translations.ru';
import {Environment} from '../../interfaces/Environment';

@Component({
  selector: 'app-error-dialog',
  templateUrl: './error-dialog.component.html',
  styleUrl: './error-dialog.component.scss'
})
export class ErrorDialogComponent {

  @Input() description: string;
  @Input() err;

  environment = inject(Environment);

  constructor(
    protected ref: NbDialogRef<ErrorDialogComponent>
  ) {
  }

  getErrorText(): string {
    if (typeof this.err === 'string') {
      return this.err;
    }

    if (this.description) {
      return this.description;
    }

    if (this.err && this.err.error && this.err.error.data) {
      return this.err.error.data;
    }

    return translations.uncheckedError;
  }

  dismiss() {
    this.ref.close();
  }
}
